import React from 'react';
import PropTypes from 'prop-types';

function MultiLine({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M20.81 5H3.19C2.532 5 2 5.576 2 6.286v11.428C2 18.424 2.533 19 3.19 19h17.62c.658 0 1.19-.576 1.19-1.286V6.286C22 5.576 21.468 5 20.81 5z" />
      <path d="M5 8c.5 0 1 .6 1 1v3c0 .333-.2 1-1 1M7 8c-.5 0-1 .5-1 1m1 4c-.333 0-1-.2-1-1" />
    </svg>
  );
}

MultiLine.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default MultiLine;
